import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=1a236b9d&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"
import style0 from "./Patient.vue?vue&type=style&index=0&id=1a236b9d&prod&lang=scss&scoped=true"
import style1 from "./Patient.vue?vue&type=style&index=1&id=1a236b9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a236b9d",
  null
  
)

export default component.exports